<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="类型">
              <a-select v-model="queryParam.transaction_record" placeholder="请选择" allowClear>
                <a-select-option :key="1" :value="1">购买卡密</a-select-option>
                <a-select-option :key="2" :value="2">转帐</a-select-option>
                <a-select-option :key="3" :value="3">充值</a-select-option>
                <a-select-option :key="4" :value="4">系统赠送</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="收入/支出">
              <a-select v-model="queryParam.direction_type" placeholder="请选择" allowClear>
                <a-select-option :key="1" :value="1">支出</a-select-option>
                <a-select-option :key="2" :value="2">收入</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced"></template>
          <a-col :md="!advanced && 6 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="() => queryParam = {}">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table ref="table" rowKey="id" :columns="columns" :data="loadData">
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <div slot="direction_type" slot-scope="text, record">
        <a-badge status="error" text="支出" v-if="record.direction_type==1" />
        <a-badge status="success" text="收入" v-else-if="record.direction_type==2" />
      </div>
      <div slot="nb_amount" slot-scope="text, record">
        <span>{{record.direction_type==1?'-':'+'}}{{ record.nb_amount/100 || 0 | currency('') }}NB</span>
      </div>
      <span slot="create_time" slot-scope="text, record">
        <span>{{ record.create_time }}</span>
      </span>
      <span slot="remark" slot-scope="text, record">
        <a-tooltip placement="top">
          <template slot="title">
            <span>{{ record.remark }}</span>
          </template>
          <span v-line-clamp="1">{{ record.remark }}</span>
        </a-tooltip>
      </span>
      <div slot="transaction_record" slot-scope="text, record">
        <a v-if="record.transaction_record == 1">购买卡密</a>
        <a v-else-if="record.transaction_record == 2">转帐</a>
        <a v-else-if="record.transaction_record == 3">充值</a>
        <a v-else-if="record.transaction_record == 4">系统赠送</a>
      </div>
    </s-table>
  </div>
</template>

<script>
const columns = [
  {
    title: '序号',
    scopedSlots: { customRender: 'serial' },
    width: 80
  },
  {
    title: '类型',
    scopedSlots: { customRender: 'transaction_record' },
    width: 150
  },
  {
    title: '收入/支出',
    scopedSlots: { customRender: 'direction_type' },
    width: 150
  },
  {
    title: '金额',
    scopedSlots: { customRender: 'nb_amount' },
    dataIndex: 'nb_amount',
    sorter: true,
    width: 150
  },
  {
    title: '备注',
    scopedSlots: { customRender: 'remark' }
  },
  {
    title: '时间',
    sorter: true,
    dataIndex: 'create_time',
    scopedSlots: { customRender: 'create_time' },
    width: 220
  }
]
import PropertyAccountApi from '@/api/property-account'
import { STable } from '@/components'
export default {
  components: {
    STable
  },
  data() {
    return {
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {},
      columns,
      loading: false,
      visible: false,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return PropertyAccountApi.getList(Object.assign(parameter, this.queryParam))
      }
    }
  },
  created() {},
  methods: {
    refresh() {
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style lang="less" scoped>
</style>
